module.exports = __webpack_public_path__ + "static/american-nations-77bc887c8b83a8d770bed09fa28c8afb.jpg";